<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='专业管理' label2="修改专业"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <!--begin: Form Body -->
          <div class="form-group m-form__group row">
            <label class="col-lg-2 col-form-label">专业名称：</label>
            <div class="col-lg-8">
              <el-form-item prop="name" :rules="{required: true, message: '专业名称不能为空', trigger: 'blur'}">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12">
                  <SaveButton :url='saveUrl' back="/system/user/list"></SaveButton>
                  <el-button type="primary" icon="el-icon-circle-plus-outline" @click="Test">测试</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EvaluationEdit',
  data () {
    return {
      form: {
        name: ''
      },
      saveUrl: this.$utils.Url.zpgl + '/api/Login/CheckLogin'
    }
  },
  methods: {
    deleteRow (index, rows) {
      rows.splice(index, 1)
    }
  }
}
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }
</style>
